export default {
  content: ''+
  '<div class="text-box">'+
  // '<h3 class="h3-line">(一)竞赛飞行时间：≥10分钟</h3>'+
  '<h3 class="h3-line">竞赛飞行流程</h3>'+
  '<p class="text-line">1.本小组选手入场进入自己的指定位置，竞赛正式开始前，确保竞赛用机处于正常的工作状态；</p>'+
  '<p class="text-line">2.选手将飞行器放至在指定起飞区域，等待第一轮射击；</p>'+
  '<p class="text-line">3.裁判发出“第一轮射击，开始”哨声后，本轮竞赛计时开始，选手启动飞行器，进入竞赛射击环节：飞行器由基地起飞，飞至飞行打靶区域，进行空中射击，完成后返回降落；</p>'+
  '<p class="text-line">4.裁判确认本轮成绩有效性；选手准备下一轮竞赛；</p>'+
  '<p class="text-line">5.按2至4执行第二至第五轮竞赛；</p>'+
  '<p class="text-line">6.裁判确认所有成绩有效性，本小组选手退场，下一小组选手入场。</p>'+
  '<p class="text-line">7.打靶场地示意图如下：</p>'+
  '<img class="img-line" src="/work/static/img/uva/XKS/t29.jpg" width="100%" />' +
  '<img class="img-line" src="/work/static/img/uva/XKS/t30.jpg" width="100%" />' +
  '</div>'
}